import { create } from 'zustand';

/**
 * Which scope's git operation is running, and a merge waiting for "keep mine /
 * keep theirs" — held OUTSIDE the Git page (owner, 05.10.2026: "if I sync and
 * switch tab it kind of stops the sync"). They were the page's own state, so
 * leaving the page forgot them: the sync went on, but coming back showed it
 * idle, and a conflict found meanwhile was dropped. Here they outlive the page.
 */
export const useScopeGitUiStore = create((set) => ({
  busyKey: null,
  setBusyKey: (key) => set({ busyKey: key == null ? null : key }),
  conflict: null,
  setConflict: (conflict) => set({ conflict: conflict || null }),
}));
